var SupportAPIHelper, SupportBaseTicketModel, SupportCallBackPhoneNumberModel, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBaseTicketModel = require('./base_ticket_model');

SupportUtilsHelper = require('../helpers/utils');

SupportAPIHelper = require('../helpers/API');

SupportCallBackPhoneNumberModel = (function(superClass) {
  extend(SupportCallBackPhoneNumberModel, superClass);

  function SupportCallBackPhoneNumberModel() {
    return SupportCallBackPhoneNumberModel.__super__.constructor.apply(this, arguments);
  }

  SupportCallBackPhoneNumberModel.prototype.initialize = function() {
    var ref;
    SupportBaseTicketModel.prototype.initialize.apply(this, arguments);
    this.getDefaultPhoneForm();
    this.userName = SupportUtilsHelper.getCurrentUserFullName() || null;
    this.userEmail = ((ref = window.currentUser) != null ? ref.email : void 0) || null;
    return this.phoneNumber = null;
  };

  SupportCallBackPhoneNumberModel.prototype.toJSON = function() {
    return {
      isLoggedIn: window.currentUser != null
    };
  };

  SupportCallBackPhoneNumberModel.prototype.getDefaultPhoneForm = function() {
    this.phoneForm = {
      method_of_contact: "callMeBackOption",
      objects: [
        {
          type: "user_name",
          label: I18n.translate('js.modules.support.user_label_full_name'),
          required: this.getRequired(),
          additional_attributes: {
            maximum_number_of_characters_or_digits: ""
          },
          value: this.userName
        }, {
          type: "email_address",
          label: I18n.translate('js.modules.support.call_me_back_email_label'),
          required: this.getRequired(),
          value: this.userEmail
        }, {
          type: "phone_number",
          label: I18n.translate('js.modules.support.call_me_back_your_number'),
          required: true
        }, {
          type: "language_dropDown",
          label: I18n.translate('js.modules.support.call_me_back_language'),
          required: true
        }, {
          type: "text_description",
          label: I18n.translate('js.modules.support.comments'),
          required: false
        }
      ]
    };
    if (Groupon.Support.FeatureFlagModel.isRecaptchaEnabled()) {
      this.phoneForm.objects.push({
        type: "recaptcha",
        required: true
      });
    }
    return this.phoneForm;
  };

  SupportCallBackPhoneNumberModel.prototype.getRequired = function() {
    if (!!this.userEmail && !!this.userName) {
      return false;
    } else {
      return true;
    }
  };

  SupportCallBackPhoneNumberModel.prototype.postToHoldTime = function(data, renderHoldTimePostSuccess, renderHoldTimePostError) {
    var successHandler, url;
    url = this.getCreateCallBackUrl();
    successHandler = function(response) {
      return renderHoldTimePostSuccess(response, data.locale, data.user_given_phone);
    };
    return SupportAPIHelper.call(url, 'POST', data, successHandler, renderHoldTimePostError, false);
  };

  SupportCallBackPhoneNumberModel.prototype.getCreateCallBackUrl = function() {
    var deal_type, ref, url;
    deal_type = (ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0;
    if (deal_type != null) {
      url = window.SUPPORTBASEURL + "/hold_time/create?deal_type=" + deal_type + "&country_code=" + window.I18n.country;
    } else {
      url = window.SUPPORTBASEURL + "/hold_time/create?country_code=" + window.I18n.country;
    }
    if (window.experiments.shouldEnableSBR && Groupon.Support.FeatureFlagModel.isSBREnabled() && (window.rating != null) && window.rating > 0) {
      url = url + ("&customer_rating=" + window.rating);
    }
    return SupportUtilsHelper.addMetaDataQueryParams(url);
  };

  return SupportCallBackPhoneNumberModel;

})(SupportBaseTicketModel);

module.exports = SupportCallBackPhoneNumberModel;

//# sourceMappingURL=data:application/json;base64,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
